/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Ismanuallycreated2Inputs */

const de__field_ismanuallycreated2 = /** @type {(inputs: _Field_Ismanuallycreated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist manuelle Bestellung?`)
};

/**

* @param {_Field_Ismanuallycreated2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_ismanuallycreated2 = /** @type {((inputs?: _Field_Ismanuallycreated2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Ismanuallycreated2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_ismanuallycreated2(inputs)
});
export { _field_ismanuallycreated2 as "_field_isManuallyCreated" }